import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon, ArrowRightIcon, UsersIcon } from 'lucide-react';
export function HcpGroupingSlide({
  onNext,
  onBack
}: {
  onNext: () => void;
  onBack: () => void;
}) {
  const groups = [{
    name: 'Urgent lump clinic',
    count: 14,
    color: 'rose'
  }, {
    name: 'Routine lump clinic',
    count: 8,
    color: 'amber'
  }, {
    name: 'Pain clinic',
    count: 8,
    color: 'sky'
  }];
  return <div className="flex flex-col h-full px-6 py-8 relative z-10 bg-slate-950 text-slate-300" data-id="element-175">
      <div className="flex items-center justify-between mb-6" data-id="element-176">
        <button onClick={onBack} className="p-2 -ml-2 text-slate-400 hover:text-white transition-colors bg-slate-900 rounded-full shadow-sm border border-slate-800" aria-label="Go back" data-id="element-177">
          <ArrowLeftIcon className="w-5 h-5" data-id="element-178" />
        </button>
      </div>

      <div className="flex-1 flex flex-col max-w-sm mx-auto w-full overflow-y-auto no-scrollbar pb-20" data-id="element-179">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-8" data-id="element-180">
          <h2 className="text-2xl font-semibold text-white leading-tight mb-4" data-id="element-181">
            Patients can be grouped before clinic day
          </h2>

          <p className="text-slate-400 leading-relaxed" data-id="element-182">
            Responses can be organized into meaningful clinic groups before a
            consultant reviews the list.
          </p>
        </motion.div>

        <div className="space-y-4 mb-8" data-id="element-183">
          {groups.map((g, i) => <motion.div key={g.name} initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2 + i * 0.15
        }} className={`bg-${g.color}-500/10 border border-${g.color}-500/20 rounded-2xl p-5 flex items-center justify-between`} data-id="element-184">
              <div data-id="element-185">
                <h3 className="text-white font-medium mb-1" data-id="element-186">{g.name}</h3>
                <div className="flex items-center space-x-1.5 text-slate-400 text-sm" data-id="element-187">
                  <UsersIcon className="w-4 h-4" data-id="element-188" />
                  <span data-id="element-189">{g.count} patients</span>
                </div>
              </div>

              {/* Visual representation of patients in this group */}
              <div className="flex -space-x-2" data-id="element-190">
                {[...Array(Math.min(g.count, 5))].map((_, j) => <motion.div key={j} initial={{
              opacity: 0,
              x: -10
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: 0.5 + i * 0.1 + j * 0.05
            }} className={`w-8 h-8 rounded-full bg-slate-800 border-2 border-slate-900 flex items-center justify-center`} data-id="element-191">
                    <div className={`w-2 h-2 rounded-full bg-${g.color}-400`} data-id="element-192" />
                  </motion.div>)}
                {g.count > 5 && <div className="w-8 h-8 rounded-full bg-slate-800 border-2 border-slate-900 flex items-center justify-center text-[10px] font-bold text-slate-400 z-10" data-id="element-193">
                    +{g.count - 5}
                  </div>}
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1
      }} className="bg-slate-800/50 border border-slate-700/50 p-4 rounded-xl" data-id="element-194">
          <p className="text-sm text-slate-400 leading-relaxed text-center" data-id="element-195">
            Consultants review grouped patients instead of sorting individual
            referrals one by one.
          </p>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 1.2
    }} className="absolute bottom-6 left-6 right-6" data-id="element-196">
        <button onClick={onNext} className="w-full py-4 bg-nhs-blue text-white rounded-xl font-semibold text-lg flex items-center justify-center hover:bg-nhs-darkblue transition-colors shadow-lg shadow-nhs-blue/20 active:scale-[0.98] group" data-id="element-197">
          View by professional role
          <ArrowRightIcon className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-198" />
        </button>
      </motion.div>
    </div>;
}